(() => {
  "use strict";

  /**
   * Loads mega menu images from data-src when panels open.
   * Uses MutationObserver so we do not miss any menu interaction path.
   */
  function initMegaMenuLazyLoad() {
    const loadImages = (root) => {
      if (!root) return;

      root.querySelectorAll("img.js-mega-menu-lazy[data-src]").forEach((img) => {
        const src = img.getAttribute("data-src");
        if (!src) return;

        img.src = src;
        img.removeAttribute("data-src");
      });
    };

    const initMenuSliders = (root) => {
      if (!root) return;

      root.querySelectorAll("convx-menu-slider").forEach((slider) => {
        if (typeof slider.updateFlickity === "function") {
          slider.updateFlickity();
        }
      });
    };

    const hydrateDropdown = (dropdown) => {
      if (!dropdown) return;

      loadImages(dropdown.querySelector(".convx__mega-menu-left-section"));
      loadImages(dropdown.querySelector(".convx__mega-menu-new-arrivals"));

      const activePanel =
        dropdown.querySelector(".convx__third-level-nav.active")
        || dropdown.querySelector(".convx__mega-menu-right-section .convx__third-level-nav");

      loadImages(activePanel);
      initMenuSliders(dropdown.querySelector(".convx__mega-menu-new-arrivals"));
      initMenuSliders(activePanel);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;

        const target = mutation.target;
        if (!(target instanceof Element)) return;

        if (target.classList.contains("mega-dropdown") && target.classList.contains("open")) {
          hydrateDropdown(target);
        }

        if (target.classList.contains("convx__third-level-nav") && target.classList.contains("active")) {
          loadImages(target);
          initMenuSliders(target);
        }

        if (target.classList.contains("convx__dropdown") && target.classList.contains("open")) {
          loadImages(target);
          initMenuSliders(target);
        }

        if (target.classList.contains("convx__drawer") && target.classList.contains("convx__drawer-open")) {
          loadImages(target);
          initMenuSliders(target);
        }
      });
    });

    const observeClassChanges = (selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        observer.observe(element, { attributes: true, attributeFilter: ["class"] });
      });
    };

    observeClassChanges(".mega-dropdown");
    observeClassChanges(".convx__third-level-nav");
    observeClassChanges("#convx__mobile-menu .convx__dropdown");
    observeClassChanges("#convx__mobile-menu .convx__drawer");
  }

  // Function to toggle scroll on body
  function toggleBodyScroll(disable, where) {
    if (disable && !document.body.classList.contains("no-scroll")) {
      document.body.classList.add("no-scroll");
      // console.log("Scroll disabled", where);
    } else if (!disable && document.body.classList.contains("no-scroll")) {
      document.body.classList.remove("no-scroll");
      // console.log("Scroll enabled",where);
    }
    
  }

  // function glideJs() {
  //   window.glideSlider = new Glide(".convx__mega-menu-new-arrivals .glide", {
  //     type: "carousel",
  //     perView: 4.5,
  //     gap: 10,
  //     breakpoints: {
  //       768: { perView: 4 },
  //       480: { perView: 3 },
  //     },
  //   }).mount();
  // }

  function desktopMenu() {
    const navLinks = document.querySelectorAll(".nav-link");
    const childLinks = document.querySelectorAll(".category-link");
    const grandchildContainers = document.querySelectorAll(
      ".convx__third-level-nav"
    );

    const containers = document.querySelectorAll(
      ".convx__nav-category-highlights"
    );

    containers.forEach((container) => {
      let isDragging = false;
      let startX, scrollLeft;

      container.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener("mouseleave", () => {
        isDragging = false;
      });

      container.addEventListener("mouseup", () => {
        isDragging = false;
      });

      container.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        container.scrollLeft = scrollLeft - walk;
      });
    });

    let isFirst = true;

    // First-Level Dropdown Toggle
    navLinks.forEach((link) => {
      link.addEventListener("mouseover", function (e) {
        e.preventDefault();
        link.classList.add("open");
        const dropdown = this.nextElementSibling;

        navLinks.forEach((tab) => {
          tab.classList.remove("open");
        });
        // Close all other dropdowns
        closeAllDropdowns();
        // Toggle the current dropdown
        if (dropdown) {
          dropdown.classList.toggle("open");
          link.classList.add("open");
          toggleBodyScroll(true, "desktop 1"); // Disable scrolling
          openFirstCategory(dropdown);
        }
        if (isFirst && link.textContent === "All Products") {
          const newArrivalElemennt = document.querySelector('.convx__desktop-mega-menu .convx__mega-menu-new-arrivals convx-menu-slider')
          if (newArrivalElemennt) {
            newArrivalElemennt.updateFlickity()
            // isFirst = false
          }
          // window.glideSlider?.update?.();
        }
      });

      link.addEventListener("click", function (e) {
        if (this.nextElementSibling?.classList.contains("mega-dropdown")) e.preventDefault();
        if (
          window.matchMedia("(pointer: coarse)").matches &&
          !e.target.closest(".mega-menu__all-products")
        ) {
          e.preventDefault();
        }
        link.classList.add("open");
        const dropdown = this.nextElementSibling;

        navLinks.forEach((tab) => {
          tab.classList.remove("open");
        });
        // Close all other dropdowns
        closeAllDropdowns();
        // Toggle the current dropdown
        if (dropdown) {
          dropdown.classList.toggle("open");
          link.classList.add("open");
          toggleBodyScroll(true, "desktop 2"); // Disable scrolling
          openFirstCategory(dropdown);
        }
        if (isFirst && link.textContent === "All Products") {
          window.glideSlider?.update?.();
        }
      });
    });

    // Second-to-Third Level Interaction
    childLinks.forEach((link) => {
      link.addEventListener("mouseover", function (e) {
        e.preventDefault();

        // Exclude links with data-parent-link="All Products"
        if (link.getAttribute("data-parent-link") === "All Products") {
          return;
        }

        const targetContainer = this.getAttribute("data-nav-child-link");
        const currentDropdown = this.closest(".mega-dropdown");

        childLinks.forEach((tab) => {
          tab.classList.remove("active");
        });
        link.classList.add("active");

        // Hide all third-level containers within the current first-level dropdown
        const grandchildContainersInDropdown = currentDropdown.querySelectorAll(
          ".convx__third-level-nav"
        );
        grandchildContainersInDropdown.forEach((container) => {
          container.classList.remove("active");
        });

        // Show the matching third-level container scoped to the current first-level context
        const activeContainer = currentDropdown.querySelector(
          `.convx__third-level-nav[data-grandchild-container="${targetContainer}"]`
        );
        if (activeContainer) {
          activeContainer.classList.add("active");
        }
      });

      link.addEventListener("click", function (e) {
        if (
          window.matchMedia("(pointer: coarse)").matches &&
          !e.target.closest(".mega-menu__all-products")
        ) {
          e.preventDefault();
        }

        // Exclude links with data-parent-link="All Products"
        if (link.getAttribute("data-parent-link") === "All Products") {
          return;
        }

        const targetContainer = this.getAttribute("data-nav-child-link");
        const currentDropdown = this.closest(".mega-dropdown");

        childLinks.forEach((tab) => {
          tab.classList.remove("active");
        });
        link.classList.add("active");

        // Hide all third-level containers within the current first-level dropdown
        const grandchildContainersInDropdown = currentDropdown.querySelectorAll(
          ".convx__third-level-nav"
        );
        grandchildContainersInDropdown.forEach((container) => {
          container.classList.remove("active");
        });

      // Show the matching third-level container scoped to the current first-level context
      const activeContainer = currentDropdown.querySelector(
        `.convx__third-level-nav[data-grandchild-container="${targetContainer}"]`
      );
      if (activeContainer) {
        activeContainer.classList.add("active");
      }
    });
  });

    function openFirstCategory(dropdown) {
    if (dropdown && !dropdown.classList.contains('mega-menu__all-products')) {
      const rightMenus = dropdown.querySelectorAll(
        ".convx__mega-menu-right-section .convx__third-level-nav"
      );
      const leftMenus = dropdown.querySelectorAll(
        ".convx__mega-menu-left-section .category-link"
      );

      leftMenus.forEach((leftMenu) => {
        leftMenu.classList.remove("active");
      });
      

      rightMenus.forEach((rightMenu) => {
        rightMenu.classList.remove("active");
      });

      if (!rightMenus[0].classList.contains('convx__keyboard-container-landing')) {
        leftMenus[0].classList.add("active");
      }
      rightMenus[0].classList.add("active");
    }
  }

    // Function to close all first-level dropdowns
    function closeAllDropdowns() {
      document.querySelectorAll(".mega-dropdown").forEach((dropdown) => {
        dropdown.classList.remove("open");
      });
      navLinks.forEach((tab) => {
        tab.classList.remove("open");
      });
      toggleBodyScroll(false, "desktop 3"); // Enable scrolling
    }

    // Close dropdowns when clicking outside
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".top-nav")) {
        if (window.innerWidth >= 769) {
          closeAllDropdowns();
        }
      }
    });

    document.addEventListener("mouseover", (e) => {
      if (!e.target.closest(".top-nav")) {
        if (window.innerWidth >= 769) {
          closeAllDropdowns();
        }
      }
    });

    document
      .querySelectorAll(".convx__mega-menu-nav-close")
      .forEach((closeBtn) => {
        closeBtn.addEventListener("click", (e) => {
          if (window.innerWidth >= 769) {
            closeAllDropdowns();
          }
        });
      });
  }

  function mobileMenu() {
    const menuHamburger = document.getElementById("menu-hamburger");
    const icon = document.querySelector("#menu-hamburger span"); // Corrected selector
    const drawers = document.querySelectorAll(
      "#convx__mobile-menu .convx__drawer"
    );
    const toggleDrawerButtons = document.querySelectorAll(
      "#convx__mobile-menu .toggle-drawer"
    );
    const toggleDropdownButtons = document.querySelectorAll(
      "#convx__mobile-menu .toggle-dropdown"
    );

    let stackIndex = 0; // Tracks the number of active drawers
    let menuOpened = false; // Tracks whether the menu is open

    // Open/Close the main menu and handle back navigation
    menuHamburger.addEventListener("click", () => {
      if (menuOpened && stackIndex > 0) {        
        // Close the topmost drawer
        const activeDrawers = [...drawers].filter((drawer) =>
          drawer.classList.contains("convx__drawer-open")
        );
        const topDrawer = activeDrawers.pop(); // Get the topmost drawer
        if (topDrawer) {
          topDrawer.classList.remove("convx__drawer-open");
          delete topDrawer.dataset.stack;
          stackIndex--;
        }

        // If all drawers are closed, reset menuOpened and icon
        if (stackIndex === 0) {
          toggleBodyScroll(false, "mobile");
          // console.log("close");
          
          menuOpened = false;
          icon.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 16 16" fill="none">
          <path d="M2.58325 3H13.4166M2.58325 8H13.4166M2.58325 13H13.4166" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`; // Hamburger icon
        }
      } else if (!menuOpened) {
        toggleBodyScroll(true, "mobile");

        // console.log("open");
        // Re-open the main menu if everything is closed
        const mainDrawer = document.getElementById("convx__menu-drawer");
        mainDrawer.classList.add("convx__drawer-open");
        mainDrawer.dataset.stack = true;
        mainDrawer.style.setProperty("--stack-index", 1);
        stackIndex = 1;
        menuOpened = true;
        icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M257.364579 512.909719 700.780551 66.759473l65.691141 60.217477L375.059118 512.909719l385.934816 383.196449-62.946634 60.217477L257.364579 512.909719z"/></svg>`; // Close icon
      }
    });

    // Toggle drawers
    toggleDrawerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const target = document.querySelector(
          `.convx__drawer[data-drawer="${button.dataset.target}"]`
        );

        if (target) {
          target.classList.add("convx__drawer-open");
          target.dataset.stack = true;
          target.style.setProperty("--stack-index", stackIndex + 1); // Increment stack index
          stackIndex++;
          menuOpened = true;
          icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M257.364579 512.909719 700.780551 66.759473l65.691141 60.217477L375.059118 512.909719l385.934816 383.196449-62.946634 60.217477L257.364579 512.909719z"/></svg>`; // Change to close icon
        }
      });
    });

    // Toggle dropdowns
    toggleDropdownButtons.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const dropdown = button.nextElementSibling;
    
        if (dropdown) {
          dropdown.classList.toggle('open');
    
          // if (dropdown.classList.contains('open') && !dropdown.dataset.glideInitialized) {
          //   dropdown.querySelectorAll(".glide").forEach((glideElement) => {
          //     let glideInstance;
    
          //     if (!glideElement.classList.contains("glide--carousel")) {
          //       // Initialize new Glide instance if not already a carousel
          //       glideInstance = new Glide(glideElement, {
          //         type: "carousel",
          //         perView: 3.2,
          //         gap: 10,
          //       }).mount();
    
          //       // Mark the element as initialized
          //       glideElement.classList.add("glide--carousel");
          //       // Save the Glide instance for updates
          //       glideElement.glideInstance = glideInstance;
          //     } else {
          //       // Update the existing Glide instance once
          //       glideInstance = glideElement.glideInstance;
    
          //       if (glideInstance) {
          //         glideInstance.update({});
          //       }
          //     }
          //   });
    
          //   // Mark the dropdown as initialized
          //   dropdown.dataset.glideInitialized = "true";
          // }
        }
      });
    });
    
  }

  function run() {
    const header = document.querySelector('store-header[data-kc-br-theme="enterprise-global-navigation-v8"]');
    if (!header || header.dataset.brMenuReady) return;
    header.dataset.brMenuReady = "true";
    initMegaMenuLazyLoad();
    desktopMenu();
    mobileMenu();
    // glideJs();
  }

  document.addEventListener("shopify:section:load", run);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();
